<section class="home-cta" aria-labelledby="home-cta-title">
  <div class="home-cta__card">
    <div class="home-cta__content">
      <div class="home-cta__heading">
        <p class="home-cta__eyebrow">{{ content.eyebrow }}</p>
        <h2 id="home-cta-title" class="home-cta__title" [innerHTML]="titleSafe"></h2>
      </div>

      <p class="home-cta__text">
        {{ content.descripcionEspecifica }}
      </p>
    </div>

    @if (isExternalUrl(content.buttonUrl)) {
      <a
        class="home-cta__button"
        [href]="content.buttonUrl"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="buttonAriaLabel"
      >
        <span [innerHTML]="buttonLabelSafe"></span>
        <svg class="home-cta__button-icon" aria-hidden="true" viewBox="0 0 24 24">
          <path d="M9 6l6 6-6 6" />
        </svg>
      </a>
    } @else if (fragmentOf(content.buttonUrl); as fragment) {
      <a
        class="home-cta__button"
        [routerLink]="[]"
        [fragment]="fragment"
        [attr.aria-label]="buttonAriaLabel"
      >
        <span [innerHTML]="buttonLabelSafe"></span>
        <svg class="home-cta__button-icon" aria-hidden="true" viewBox="0 0 24 24">
          <path d="M9 6l6 6-6 6" />
        </svg>
      </a>
    } @else if (internalLinkOf(content.buttonUrl); as link) {
      <a
        class="home-cta__button"
        [routerLink]="routerCommandsOf(link)"
        [queryParams]="link.queryParams"
        [fragment]="link.fragment"
        [attr.aria-label]="buttonAriaLabel"
      >
        <span [innerHTML]="buttonLabelSafe"></span>
        <svg class="home-cta__button-icon" aria-hidden="true" viewBox="0 0 24 24">
          <path d="M9 6l6 6-6 6" />
        </svg>
      </a>
    }
  </div>
</section>
